export default __webpack_public_path__ + "static/img_diagram@2x-26f8ac3c830fd3227ea117d6550b6a5c.png";